// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_bi-0";
export var actionModalContentContainer = "_bi-1";
export var createTagButton = "_bi-2";
export var footerContainer = "_bi-7";
export var fullWidthDivider = "_bi-3";
export var hasCreateTagButton = "_bi-4";
export var noCreateTagButton = "_bi-5";
export var tagsContainer = "_bi-6";
export var tagsModalContentContainer = "_bi-8";